import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Modal } from '@uhg-abyss/web/ui/Modal';
import { motion } from 'framer-motion';
import React, { useState } from 'react';

import { TheWidget } from './components/TheWidget';
import { Styles } from './includes/styles';

/**
 * Widget
 *
 * Displays content in a box-like format with a title and optional description. Can be collapsible and have a menu.
 *
 * @param accessor
 * @param backgroundColor
 * @param button
 * @param canFullScreen
 * @param children
 * @param collapsed
 * @param collapsible
 * @param description
 * @param icon
 * @param menu
 * @param title
 * @param withCard
 * @param panel
 * @param props
 * @returns {Element}
 * @constructor
 */
export function Widget({
  accessor = null,
  backgroundColor = 'transparent',
  button = null,
  canFullScreen = false,
  children,
  collapsed = false,
  collapsible = false,
  description = '',
  icon = '',
  menu = [],
  panel = undefined,
  title = '',
  withCard = true,
  ...props
}) {
  const [isFullscreen, setIsFullscreen] = useState(false);

  return (
    <ErrorHandler location="src/shared/ui/components/Widget/Widget.jsx">
      <motion.div
        animate="open"
        initial={{ opacity: 0 }}
        variants={{
          closed: { opacity: 0 },
          open: { opacity: 1 },
        }}
      >
        <Styles>
          <TheWidget
            {...{
              ...props,
              accessor,
              backgroundColor,
              button,
              canFullScreen,
              children,
              collapsed,
              collapsible,
              description,
              icon,
              isFullscreen,
              menu,
              panel,
              setIsFullscreen,
              title,
              withCard: panel === undefined ? withCard : !panel,
            }}
          />
          <Modal
            className="full-screen-modal widget-modal"
            isOpen={isFullscreen}
            onClose={() => {
              return setIsFullscreen(false);
            }}
            title=""
          >
            <Modal.Section>
              <TheWidget
                {...{
                  ...props,
                  accessor,
                  backgroundColor,
                  button,
                  children,
                  collapsed,
                  collapsible,
                  description,
                  icon,
                  isFullscreen,
                  menu,
                  panel,
                  setIsFullscreen,
                  title,
                  withCard: !panel || false,
                }}
              />
            </Modal.Section>
          </Modal>
        </Styles>
      </motion.div>
    </ErrorHandler>
  );
}
